var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classCls},[_c('Icon',{style:(_vm.iconStyle),attrs:{"type":_vm.icon,"size":"35"}}),(_vm.title!==false)?_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }